import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import {useCurrentState} from "../globalState";

const styles = {
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
};

function DrawerInfo(props) {

    let [drawerInfo, setDrawerInfo] = useCurrentState("drawer_info");

    return (
        <div>
            <SwipeableDrawer
                anchor="right"
                keepMounted={true}
                open={drawerInfo}
                onClose={() => setDrawerInfo(false)}
                onOpen={() => setDrawerInfo(true)}
            >{props.children}
            </SwipeableDrawer>
        </div>
    );
}

DrawerInfo.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DrawerInfo);